export default __webpack_public_path__ + "static/qubitro-dashboard-f18897f4fa19eaf118e34a0657ae3b5a.png";